var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 6.00012C4.62198 6.00012 4.26048 5.83912 4.00748 5.55712L0.791981 2.29362C0.490981 1.96462 0.418981 1.52562 0.591481 1.13462C0.763981 0.743622 1.13648 0.500122 1.56348 0.500122H8.43648C8.86348 0.500122 9.23648 0.743122 9.40848 1.13462C9.58048 1.52612 9.50848 1.96462 9.22048 2.28012L5.97698 5.57462C5.73948 5.83912 5.37798 6.00012 4.99998 6.00012ZM1.56348 1.50012C1.55048 1.50012 1.52298 1.50012 1.50648 1.53712C1.48998 1.57462 1.50848 1.59512 1.51748 1.60512L4.73598 4.87212C4.83798 4.98562 4.94448 5.00012 4.99998 5.00012C5.05548 5.00012 5.16198 4.98562 5.24848 4.88912L8.49498 1.59112C8.49498 1.59112 8.52398 1.60612 8.49348 1.53712C8.47698 1.50012 8.44948 1.50012 8.43648 1.50012H1.56348Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownClick);
export default __webpack_public_path__ + "static/media/down-click.431268a6e7314f1e5b85ceba1d450588.svg";
export { ForwardRef as ReactComponent };